import { FEDOPS_APP_NAME } from '../constants/fedops';
import { createFedopsLogger } from '../../app/services/create-fedops-logger';

let loadedLogged = false;

export const logger = createFedopsLogger(FEDOPS_APP_NAME);
export const appLoaded = () => {
  if (!loadedLogged) {
    logger.appLoaded();
    loadedLogged = true;
  }
};



// WEBPACK FOOTER //
// ./rss-feed-widget/services/fedops-logger.js